import { SVGProps, Ref, forwardRef } from 'react';

export const CloudOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.167 1.003a4.5 4.5 0 0 1 4.11 6.33A4.25 4.25 0 0 1 11.75 15h-7.5a4.25 4.25 0 0 1-2.143-7.92 3.25 3.25 0 0 1 4.205-3.9 4.5 4.5 0 0 1 3.855-2.177m0 1.4a3.1 3.1 0 0 0-2.656 1.5l-.586.97-1.07-.371a1.9 1.9 0 0 0-.448-.096L5.25 4.4a1.85 1.85 0 0 0-1.84 1.66l-.01.19q0 .245.06.473l.271 1.028-.917.536a2.85 2.85 0 0 0-1.408 2.268l-.006.195a2.85 2.85 0 0 0 2.85 2.85h7.5a2.85 2.85 0 0 0 2.835-2.559l.015-.291c0-.938-.452-1.77-1.156-2.292l-.903-.669.458-1.026a3.1 3.1 0 0 0-2.673-4.355z"
            fill="currentColor"
        />
    </svg>
));
CloudOutlinedSize16Glyph.displayName = 'CloudOutlinedSize16Glyph';
